import React, { Suspense, useState, useEffect } from 'react';
import { Spin } from 'antd';
import { useSelector, useDispatch } from 'react-redux';
import { Switch, Route, useRouteMatch } from 'react-router-dom';
import Dashboard from './dashboard';
import { setIndexCall } from '../../redux/CrmReduxCalls/EditNavCtrl';
import withAdminLayout from '../../layout/withAdminLayout';
import CancelCallUI from '../../container/dashboard/Pages/GlobalComponents/CallUI';
import MyCompanyPage from '../../container/dashboard/Popup/FirstLoginCompanyPopup'
import CompanyResearch from '../../container/dashboard/Popup/CompanyResearch'
import DataAccess from '../../container/dashboard/Popup/FirstLoginDataPopup'
import CurrecnySetting from '../../container/dashboard/Popup/FirstLoginCurrecnyPopup'
import FullScreenExplosion from '../../container/dashboard/Pages/GlobalComponents/FullScreenExplosion';

const Admin = () => {
  const dispatch = useDispatch();
  const { path } = useRouteMatch();
  const [companyPage, setCompanyPage] = useState(false)
  const [scondOpen, setScondOpen] = useState(false)
  const [thiredOpen, setThiredOpen] = useState(false)
  const localData = useSelector((state) => state.localRedux);
  const showExplosion = useSelector((state) => state.explosion.explo);
  const showResearch = useSelector((state) => state.aiRedux);
  const companyProfile = localData.company
  const ProfileData = localData.profile
  const profile = ProfileData
  useEffect(() => {
    if ((profile.companyRole === "Administrator" || profile.companyRole === "CEO") && companyProfile) {
      const {
        country, state, city, timeZone, salesCycle, monthName, accountUrl, loginSetupStatus
        // industry, companySize,
      } = companyProfile;
      const missingFields = (!country || !state || !city || !timeZone || !salesCycle || !monthName || accountUrl === "" || !accountUrl) // || !industry || !companySize 
      if (missingFields) {
        const timer = setTimeout(() => {
          setCompanyPage(true);
        }, 3000);
        return () => clearTimeout(timer);
      }
      setCompanyPage(false);
      const newScondOpen = profile.companyRole === "CEO" && loginSetupStatus === "Company";
      const newThiredOpen = (((profile.companyRole === "Administrator" || profile.companyRole === "CEO") && loginSetupStatus === "DemoSetup") || (profile.companyRole === "Administrator" && loginSetupStatus === "Company"));
      if (newScondOpen) {
        setScondOpen(true)
      }
      else if (newThiredOpen) {
        setScondOpen(false)
        setThiredOpen(true)
      }
      else {
        setScondOpen(false)
        setThiredOpen(false)
      }
      if (!missingFields && !newScondOpen && !newThiredOpen) {
        dispatch(setIndexCall("Callapi"));
      }
    } else {
      dispatch(setIndexCall("Callapi"));
    }
  }, [companyProfile]);
  return (<>
    <Switch>
      <Suspense
        fallback={
          <div className="spin">
            <Spin />
          </div>
        }
      >
        <Route path={path} component={Dashboard} />
      </Suspense>
    </Switch>
    <CancelCallUI />
    <FullScreenExplosion active={showExplosion} />
    {companyPage && <MyCompanyPage companyPage={companyPage} setCompanyPage={setCompanyPage} />}
    {scondOpen && <DataAccess open={scondOpen} setOpen={setScondOpen} />}
    {thiredOpen && <CurrecnySetting open={thiredOpen} setOpen={setThiredOpen} />}
    <CompanyResearch currency={showResearch.openResearch} AllLeads={showResearch.saveTotalLeadCount} pageFrom={showResearch.pageFrom} dataFrom={showResearch.openResearchData} openResearchType={showResearch.openResearchType} />
  </>
  );
}

export default withAdminLayout(Admin);
